import { useState } from "react";
import classNames from "classnames";

import { CPermission } from "src/1/common/components/others";
import { ChevronDown } from "src/common/assets/icons";
import navigation from "src/routes/navigation";

import { SIDEBAR_WIDTH } from "../constants";

import { CNavList } from "./CNavList";

const CSidebar = () => {
  const [open, setOpen] = useState(false);

  const onToggle = () => setOpen(!open);

  return (
    <div
      className="custom-sidebar bg-white h-[inherit] flex flex-col transition-all duration-200 shadow-[2px_0_5px_0_rgba(0,0,0,0.1)]"
      style={{
        width: open ? SIDEBAR_WIDTH.FULL : SIDEBAR_WIDTH.MINI,
      }}
    >
      <div className="text-black border-b border-solid border-blue-100 !py-3 !px-4 flex items-center justify-end">
        <button
          onClick={onToggle}
          className={classNames(
            "rotate-90 rounded-full outline-none transition-all duration-75 text-[#053C7F]",
            open ? "rotate-90" : "rotate-[270deg]",
          )}
        >
          <ChevronDown />
        </button>
      </div>
      <ul
        className="!py-3 flex-1 mb-0 max-w-full overflow-y-auto navigations-list"
        style={{ scrollbarWidth: "none" }}
      >
        {navigation.map((nav) => (
          <CPermission key={nav.route + nav.name} permissions={nav.permissions}>
            <CNavList data={nav} sidebarOpen={open} />
          </CPermission>
        ))}
      </ul>
      <div className="text-black border-t border-solid border-blue-100 !py-3 !px-4 flex items-center justify-end">
        <button
          onClick={onToggle}
          className={classNames(
            "rotate-90 rounded-full outline-none transition-all duration-75 text-[#053C7F]",
            open ? "rotate-90" : "rotate-[270deg]",
          )}
        >
          <ChevronDown />
        </button>
      </div>
    </div>
  );
};

export default CSidebar;
